import "core-js/modules/es.array.join";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.entries";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react'; // import PropTypes from 'prop-types';

import hoistNonReactStatics from 'hoist-non-react-statics';
import getDisplayName from '@material-ui/utils/getDisplayName';
import useTheme from '@material-ui/core/styles/useTheme'; // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withThemeProps = function withThemeProps() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        name = options.name;

    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withThemeProps()(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var WithThemeProps = React.forwardRef(function WithThemeProps(props, ref) {
      var more = typeof name === 'string' && name ? function () {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var theme = useTheme() || defaultTheme;
        return Object.entries((theme.props || {})[name] || {}).reduce(function (r, _ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              k = _ref2[0],
              v = _ref2[1];

          return r[k] === undefined ? _extends({}, r, _defineProperty({}, k, v)) : r;
        }, props);
      }() : props;
      return React.createElement(Component, _extends({
        ref: ref
      }, more));
    });
    WithThemeProps.propTypes = {};
    WithThemeProps.defaultProps = {};

    if (process.env.NODE_ENV !== 'production') {
      WithThemeProps.displayName = "WithThemeProps(".concat(getDisplayName(Component), ")");
    }

    hoistNonReactStatics(WithThemeProps, Component);

    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      WithThemeProps.Naked = Component;
      WithThemeProps.options = options;
    }

    return WithThemeProps;
  };
};

export default withThemeProps;